import React from "react";
import styled from "styled-components";
import GlobalStyles from "../Styles/Index";
import { Colors } from "../../assets/Res/Colors";
import TrackIcon from "../../assets/Images/track.svg";
import QuoteIcon from "../../assets/Images/quote.svg";
import { PrimaryButton } from "../Button/Index";
import { IconIMG } from "../Images/Index";
import { useNavigate } from "react-router";

const CardsWrapper = styled.div`
  width: 80%;
  height: fit-content;
  margin: 10vh 10% 5vh 10%;
`;

const Cards = () => {
  const navigate = useNavigate();
  const cardData = [
    {
      head: "Track Remotely",
      body: "Track your parcel with more convenience with just your tracking number, it is easy to get the full details of your parcels destination, anywhere, anytime",
      btn: {
        btnText: "Track Parcel",
        btnColor: Colors.YELLOW,
        btnBgColor: Colors.RED,
        btnWidth: "25%",
        btnFn: () => {
          navigate("/track");
        },
      },
      icon: TrackIcon,
      bgColor: Colors.YELLOW,
      textColor: Colors.RED,
    },
    {
      head: "Check Quotes",
      body: "Track your parcel with more convenience with just your tracking number, it is easy to get the full details of your parcels destination, anywhere, anytime",
      btn: {
        btnText: "Check Quote",
        btnColor: Colors.RED,
        btnBgColor: Colors.YELLOW,
        btnWidth: "25%",
        btnFn: () => {
          navigate("/quote");
        },
      },
      icon: QuoteIcon,
      bgColor: Colors.RED,
      textColor: Colors.YELLOW,
    },
  ];
  return (
    <>
      <CardsWrapper
        style={{
          ...GlobalStyles.HorizontalFlex,
          justifyContent: "space-evenly",
        }}
      >
        {cardData.map((item, index) => Card(item, index))}
      </CardsWrapper>
    </>
  );
};

const CardWrapper = styled.div`
  border-radius: 20px;
  padding: 40px;
  width: 35%;
  height: 90%;
  background-color: ${(props) => (props.bgColor ? props.bgColor : "")};
`;

const HeadText = styled.p`
  font-family: Helvetica;
  font-size: 2.5rem;
  font-weight: 600;
  text-align: left;
  color: ${(props) => (props.textColor ? props.textColor : "")};
`;

const BodyText = styled.p`
  font-family: Helvetica;
  font-size: 1rem;
  text-align: left;
  color: ${(props) => (props.textColor ? props.textColor : "")};
`;

const IconWrapper = styled.div`
  width: 100%;
`;
const EmptyWrapper = styled.div`
  width: 50%;
`;

function Card(item, index) {
  return (
    <>
      <CardWrapper key={index.toString()} bgColor={item.bgColor}>
        <HeadText textColor={item.textColor}>{item.head}</HeadText>
        <BodyText textColor={item.textColor}>{item.body}</BodyText>
        <PrimaryButton
          text={item.btn.btnText}
          color={item.btn.btnColor}
          bgColor={item.btn.btnBgColor}
          width={item.btn.btnWidth}
          onClick={item.btn.btnFn}
          padding={"5px 10px 5px 10px"}
        />
        <IconWrapper style={{ ...GlobalStyles.HorizontalFlex }}>
          <EmptyWrapper />
          <IconIMG icon={item.icon} height={"300px"} width={"300px"} />
        </IconWrapper>
      </CardWrapper>
    </>
  );
}

export default Cards;
